import { Action } from "redux";
import { BIOMETRICS_ACTIONS } from "../actions";

export type TBioResponse = 200 | 201 | 202 | 203 | 400;

export interface ITODO {
  on: boolean;
}

export interface IBiometryData {
  date?: string;
  response: TBioResponse;
  message: string;
  card: string;
}

export interface IBiometry extends ITODO {
  required: boolean;
  data?: IBiometryData;
}

export interface IBioAction extends Action {
  payload?: IBiometry;
}

const INITIAL_STATE = {
  on: true,
  required: false,
} as IBiometry;

export interface IBiometryAction extends Action {
  payload: any;
}

function biometryReducer(state = INITIAL_STATE, action: IBiometryAction) {
  switch (action.type) {
    case BIOMETRICS_ACTIONS.REQUIRE:
      return { ...state, required: action.payload };
    case BIOMETRICS_ACTIONS.FETCH_DATA:
      return { ...state, data: action.payload };
      break;
    case BIOMETRICS_ACTIONS.CLEAR:
      return INITIAL_STATE;
    default:
      return state;
  }
}

export default biometryReducer;
